import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE, PHONE_HREF, scrollToId } from "@/lib/site";

const LINKS = [
    { id: "angebote", label: "Angebote" },
    { id: "preise", label: "Preise" },
    { id: "verfuegbarkeit", label: "Verfügbarkeit" },
    { id: "galerie", label: "Galerie" },
    { id: "bewertungen", label: "Bewertungen" },
    { id: "kontakt", label: "Kontakt" },
    { id: "team", label: "Komm in unser Team" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };
    return (
        <header className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#120E09]/70 backdrop-blur-xl">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
                <button data-testid="nav-logo" onClick={() => go("start")} aria-label="Zum Seitenanfang">
                    <Logo />
                </button>
                <nav className="hidden items-center gap-8 lg:flex" aria-label="Hauptnavigation">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="text-sm text-[#9C917D] transition-colors duration-200 hover:text-[#EDE6DA]"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>
                <div className="hidden items-center gap-4 lg:flex">
                    <a
                        data-testid="nav-phone-link"
                        href={PHONE_HREF}
                        className="flex items-center gap-2 text-sm text-[#C88A45] transition-colors duration-200 hover:text-[#DBA057]"
                    >
                        <Phone size={15} /> {PHONE}
                    </a>
                    <button
                        data-testid="nav-cta-button"
                        onClick={() => go("kontakt")}
                        className="rounded-full bg-[#C88A45] px-5 py-2 text-sm font-semibold text-[#120E09] transition-[background-color,transform] duration-200 hover:bg-[#DBA057] active:scale-95"
                    >
                        Anfrage senden
                    </button>
                </div>
                <button
                    data-testid="nav-mobile-toggle"
                    className="text-[#EDE6DA] lg:hidden"
                    onClick={() => setOpen(!open)}
                    aria-label="Menü öffnen"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            {open && (
                <nav className="border-t border-white/5 bg-[#120E09] px-6 py-6 lg:hidden" aria-label="Mobile Navigation">
                    <div className="flex flex-col gap-5">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`nav-mobile-link-${l.id}`}
                                onClick={() => go(l.id)}
                                className="text-left font-display text-2xl text-[#EDE6DA]"
                            >
                                {l.label}
                            </button>
                        ))}
                        <a data-testid="nav-mobile-phone" href={PHONE_HREF} className="flex items-center gap-2 text-[#C88A45]">
                            <Phone size={16} /> {PHONE}
                        </a>
                    </div>
                </nav>
            )}
        </header>
    );
};
